import React , { useState, useEffect }from 'react';
import GoogleMapReact from 'google-map-react';
import { Container } from "react-bootstrap";
import axios from 'axios';
import './near-me.css';
import SyncLoader from "react-spinners/SyncLoader";
 
export default function NearMe (props) {
  // console.log(props);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [clinics, setClincs] = useState([null]);
  const center = props.location.state; 
  const zoom = 12;


  const renderMarkers = (map, maps) => {
    let markers; 
    // new maps.Marker({
    // position: { lat: center.lat, lng: center.lng },
    // map,
    // title:"My location"
    // });
    for (let i=0; i < clinics.length; i++){
      let clinic = clinics[i];
      let marker = new maps.Marker({
        position: { lat: clinic.location.lat, lng: clinic.location.lng },
        map,
        title: clinic.name,
        });
      // markers.push(marker);

      addClickListener(maps, map, clinic, marker)
    }
    return markers;
   };

   const addClickListener = (maps, map, clinic, marker) => {
    let infowindow = new maps.InfoWindow();
    let content = 'Location: ' + clinic.clinic_name + '<br/>Lat: ' + clinic.location.lat + '<br/>Long: ' + clinic.location.lng ;
    marker.addListener('click', ()=>{     
      infowindow.setContent(content);  
      infowindow.open(map, marker); 
    });
   }
  
  useEffect(() => {
    axios.get('https://uae-dentist-backend.herokuapp.com/location-of-clinics')
      .then(
        (result) => {
            let clinics = result.data;
            clinics.forEach( clinic => clinic.location = JSON.parse(clinic.location));
            console.log(clinics)
            setIsLoaded(true);
            setClincs(clinics);
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )
  }, [])
 
  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return (
      <div className='mt-5'>
      <SyncLoader
      size={20}
      margin={3}
      color={"#123abc"}
      loading={!isLoaded}
      />
    </div>
    )
  } else {
    return (
    <Container className='mt-3 p-0' fluid>
      <div style={{ height: '100vh', width: '100%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyBKMzsTYEHrnlFQurwvYP2DCV0AJtM4GCY" }}
          defaultCenter={center}
          defaultZoom={zoom}
          onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
          yesIWantToUseGoogleMapApiInternals={true} 
        >
        </GoogleMapReact>
      </div>
    </Container>

    );
  }

}